import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { LayoutDashboard, Boxes, FileText, GitCompareArrows, Tags, LogOut, ExternalLink, Image } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useSEO } from "../../lib/seo";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/software", label: "Software", icon: Boxes },
  { to: "/admin/articles", label: "Guides", icon: FileText },
  { to: "/admin/comparisons", label: "Comparisons", icon: GitCompareArrows },
  { to: "/admin/categories", label: "Categories", icon: Tags },
  { to: "/admin/media", label: "Media", icon: Image },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  useSEO({ title: "Admin", description: "", noindex: true });

  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-slate-100 flex">
      <aside className="w-56 bg-slate-900 text-slate-300 flex flex-col shrink-0">
        <div className="px-4 py-5 border-b border-slate-800">
          <p className="font-heading font-bold text-white text-sm">PoolServiceGuide</p>
          <p className="text-xs text-slate-500 mt-0.5">Content Manager</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActive ? "bg-sky-500 text-white" : "hover:bg-slate-800 hover:text-white"
                }`
              }
            >
              <l.icon className="w-4 h-4" aria-hidden="true" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-800 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2.5 px-3 py-2 rounded-md text-sm font-medium hover:bg-slate-800 hover:text-white transition-colors duration-200">
            <ExternalLink className="w-4 h-4" aria-hidden="true" /> View site
          </a>
          <button
            data-testid="admin-logout-button"
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-md text-sm font-medium hover:bg-slate-800 hover:text-white transition-colors duration-200"
          >
            <LogOut className="w-4 h-4" aria-hidden="true" /> Log out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  );
}
